<template>
    <div>
        <div
            style="position: -webkit-sticky; position: sticky; top: 48px; background-color:white; z-index:1;"
        >
            <v-container class="pa-0" fluid>
                <v-row no-gutters align="center">
                    <v-col cols="6" md="2" order="1">
                        <v-text-field
                            class="mr-5"
                            v-model.trim="searchQuery"
                            label="Szukaj"
                            prepend-inner-icon="mdi-magnify"
                            maxlength="100"
                            clearable
                        ></v-text-field>
                    </v-col>
                    <v-col cols="6" md="2" order="3" order-md="2">
                        <v-select
                            class="mr-5"
                            :loading="systemIndexing"
                            v-model="systemId"
                            :items="systems"
                            item-text="SystemName"
                            item-value="SystemID"
                            label="W systemach"
                            :disabled="!systems.length"
                            clearable
                        ></v-select>
                    </v-col>
                    <v-col cols="6" md="2" order="4" order-md="3">
                        <v-select
                            class="mr-md-5"
                            :loading="blockIndexing"
                            v-model="blockId"
                            :items="blocks"
                            item-text="BlockName"
                            item-value="BlockID"
                            label="W bryłach"
                            :disabled="!blocks.length"
                            clearable
                        ></v-select>
                    </v-col>
                    <v-col cols="12" md="3" order="5" order-md="4">
                        <v-row align="center" class="flex-nowrap ma-0">
                            <v-select
                                :loading="tagIndexing"
                                v-model="tagIds"
                                :items="tags"
                                item-text="Content"
                                item-value="TagID"
                                label="Tagi"
                                :disabled="!tags.length"
                                multiple
                                class="mr-2"
                            ></v-select>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" icon @click="showPackageStockLevelsExportDialog">
                                        <v-icon>mdi-file-export-outline</v-icon>
                                    </v-btn>
                                </template>
                                <span>Eksportuj stany magazynowe</span>
                            </v-tooltip>
                        </v-row>
                    </v-col>
                    <v-col cols="6" md="3" order="2" order-md="5" class="text-right">
                        <span class="body-2 text--secondary d-none d-sm-inline">{{ from }}-{{ to }} z {{ total }}</span>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on" :disabled="isPageFirst" @click="prevPage">
                                    <v-icon>mdi-chevron-left</v-icon>
                                </v-btn>
                            </template>
                            <span>Poprzednia strona</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on" :disabled="isPageLast" @click="nextPage">
                                    <v-icon>mdi-chevron-right</v-icon>
                                </v-btn>
                            </template>
                            <span>Następna strona</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-container>
            <hr class="mb-1">
        </div>

        <loading-message v-if="packageIndexing" :message="loadingMessage" class="my-5"></loading-message>
        <v-simple-table v-else-if="packages.length" fixed-header :height="tableHeight" style="table-layout: auto;">
            <template v-slot:default>
                <thead>
                    <tr>
                        <th>Aktywny</th>
                        <th>Domyślny</th>
                        <th>Produkt</th>
                        <th>EAN</th>
                        <th>Kod</th>
                        <th class="text-center">Tagi</th>
                        <th class="text-center">Cena</th>
                        <th class="text-center">Zdjęcia</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                <tr
                    v-for="pkg in packages"
                    :key="pkg.PackageID"
                >
                    <td>
                        <package-activation-switch :pkg="pkg"></package-activation-switch>
                    </td>
                    <td>
                        <package-default-switch :pkg="pkg" @defaultPackageSet="packageIndex"></package-default-switch>
                    </td>
                    <th class="text-no-wrap" style="cursor: pointer" @click="showPackageEditDialog(pkg)">
                        {{ pkg.System.SystemName }} /
                        {{ pkg.Block.BlockName }} /
                        {{ pkg.UnitColor.UnitColorName }}
                        {{ pkg.FrontUnitColor ? "/ "+pkg.FrontUnitColor.UnitColorName : "" }}
                        <br>
                        <div class="font-weight-regular text-caption text--secondary">
                            {{ pkg.Block.UnitType.UnitTypeName }}
                        </div>
                    </th>
                    <td class="text-no-wrap">
                        <span v-if="!pkg.EAN" class="red--text text--darken-2 font-italic">- brak -</span>
                        <template v-else>{{ pkg.EAN }}</template>
                    </td>
                    <td class="text-no-wrap">{{ pkg.PackageCode }}</td>
                    <td class="text-center text-no-wrap" style="width: 100%;">
                        <v-chip
                            v-for="tag in pkg.Tags"
                            :key="tag.TagID"
                            color="primary"
                            class="ma-2"
                            small
                        >
                            {{tag.Content}}
                        </v-chip>
                    </td>
                    <td class="text-center text-no-wrap">
                        <span v-if="!pkg.PricePLN" class="font-italic">- brak ceny -</span>
                        <template v-else>{{ pkg.PricePLN.toFixed(2) }} PLN</template>
                    </td>
                    <td class="text-center text-no-wrap">
                        <v-row v-if="pkg.PackageImages.length > 0" class="flex-nowrap ma-1">
                            <div
                                v-for="(image, i) in pkg.PackageImages.slice(0, displayImageNumber)" 
                                :key="image.PackageImageID"
                                class="ma-1"
                                style="
                                    width: 60px;
                                    height: 60px;
                                    border-radius: 6px;
                                    overflow: hidden;
                                    position: relative;
                                    cursor: pointer;
                                "
                                @click="showPackageImageDisplayDialog(pkg, i)"
                            >
                                <img 
                                    :src="image.ImageUrl"
                                    :alt="`Zdjęcie-${image.PackageImageID}`"
                                    style="
                                        width: 100%;
                                        height: 100%;
                                        object-fit: cover;
                                    "
                                />
                                <template v-if="i === displayImageNumber - 1 && pkg.PackageImages.length > displayImageNumber">
                                    <div
                                        class="blue-grey darken-2"
                                        style="position: absolute; inset: 0; opacity: 0.5"
                                    >
                                    </div>
                                    <div 
                                        class="text-h6 white--text text-center"
                                        style="
                                            position: absolute;
                                            top: 50%;
                                            left: 50%;
                                            translate: -50% -50%;
                                        "
                                    >
                                        +{{ pkg.PackageImages.length - displayImageNumber }}
                                    </div>
                                </template>
                            </div>
                        </v-row>
                        <span v-else class="font-italic">- brak zdjęć -</span>
                    </td>
                    <td class="text-right">
                        <v-menu bottom left rounded :offset-y="true">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn small icon v-bind="attrs" v-on="on">
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>

                            <v-list dense>
                                <v-list-item>
                                    <v-list-item-title>
                                        <a @click="showPackageImageStoreDialog(pkg)">
                                            <v-icon small>mdi-image-multiple-outline</v-icon>
                                            Zarządzaj zdjęciami
                                        </a>
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </td>
                </tr>
                </tbody>
            </template>
        </v-simple-table>
        <v-alert
            v-else
            border="left"
            colored-border
            type="info"
            elevation="1"
        >{{ emptyMessage }}</v-alert>

        <v-dialog
            v-model="packageEditDialog"
            persistent
            width="500"
        >
            <v-card v-if="packageToEdit">
                <v-card-title class="headline grey lighten-2 mb-5">
                    Edycja kompletu
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="hidePackageEditDialog"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-text-field
                        :value="packageToEdit.System.SystemName"
                        label="System"
                        disabled
                    ></v-text-field>
                    <v-text-field
                        :value="packageToEdit.Block.BlockName"
                        label="Bryła"
                        disabled
                    ></v-text-field>
                    <v-text-field
                        :value="`${packageToEdit.UnitColor.UnitColorName}${packageToEdit.FrontUnitColor ? ' / '+packageToEdit.FrontUnitColor.UnitColorName : ''}`"
                        label="Kolor"
                        disabled
                    ></v-text-field>
                    <v-text-field
                        v-model="packageForm.EAN"
                        label="EAN*"
                        maxlength="13"
                        :counter="13"
                        :error="$store.getters.hasValidationError('EAN')"
                        :error-messages="$store.getters.validationError('EAN')"
                    ></v-text-field>
                    <v-text-field
                        v-model="packageForm.PricePLN"
                        label="Cena PLN*"
                        type="number"
                        step="0.01"
                        min="0"
                        max="9999.99"
                        :error="$store.getters.hasValidationError('PricePLN')"
                        :error-messages="$store.getters.validationError('PricePLN')"
                    ></v-text-field>
                    <v-text-field
                        v-model="packageForm.ExternalCodeBRW"
                        label="Kod BRW"
                        maxlength="256"
                        :error="$store.getters.hasValidationError('ExternalCodeBRW')"
                        :error-messages="$store.getters.validationError('ExternalCodeBRW')"
                    ></v-text-field>
                    <v-select
                        v-model="packageForm.TagIDs"
                        :items="tags"
                        label="Tagi"
                        multiple
                        chips
                        item-text="Content"
                        item-value="TagID"
                        :error="$store.getters.hasValidationError('TagIDs')"
                        :error-messages="$store.getters.validationError('TagIDs')"
                    ></v-select>
                    <small>* pole wymagane</small>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        rounded
                        color="success"
                        @click="packageUpdate"
                        :loading="packageUpdating"
                    >Zapisz</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="packageImageDisplayDialog"
            width="1000"
        >
            <div v-if="packageToDisplayPackageImage" style="position: relative">
                <v-carousel
                    v-model="packageImageDisplayIndex"
                    show-arrows-on-hover
                    :height="Math.min(500, $vuetify.breakpoint.width / 2)"
                >
                    <v-carousel-item
                        v-for="image in packageToDisplayPackageImage.PackageImages"
                        :key="image.PackageImageID"
                    >
                        <v-sheet color="black" height="100%" tile>
                            <img 
                                :src="image.ImageUrl"
                                :alt="`Zdjęcie-${image.PackageImageID}`"
                                style="width: 100%; height: 100%; object-fit: contain"
                            />
                        </v-sheet>
                    </v-carousel-item>
                </v-carousel>
                <div
                    class="black"
                    style="
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        height: 50px;
                        opacity: 0.3;
                    "
                >
                </div>
                <div 
                    class="white--text text-center"
                    style="
                        position: absolute;
                        top: 4px;
                        left: 50%;
                        translate: -50%;
                        opacity: 0.8;
                    "
                >
                    <div class="caption text-no-wrap">
                        {{ packageToDisplayPackageImage.System.SystemName }}
                        {{ packageToDisplayPackageImage.Block.BlockName }},
                        {{ packageToDisplayPackageImage.UnitColor.UnitColorName }}
                        {{ packageToDisplayPackageImage.FrontUnitColor 
                            ? "/ " + packageToDisplayPackageImage.FrontUnitColor.UnitColorName 
                            : "" 
                        }}
                    </div>
                    <div class="text-h6" style="line-height: 1.6rem">
                        {{ packageToDisplayPackageImage.PackageCode }}
                    </div>
                </div>
            </div>
        </v-dialog>

        <v-dialog
            v-model="packageImageStoreDialog"
            persistent
            width="596"
        >
            <v-card v-if="packageToStorePackageImage">
                <v-card-title class="headline grey lighten-2 mb-5">
                    Zarządzanie zdjęciami kompletu {{packageToStorePackageImage.PackageCode}}
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="hidePackageImageStoreDialog"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <div class="text-h6">
                        Aktualne zdjęcia ({{ packageToStorePackageImage.PackageImages.length }}/{{ maxImageNumber }})
                    </div>

                    <v-row class="ma-1">
                        <div
                            v-for="image in packageToStorePackageImage.PackageImages" 
                            :key="image.PackageImageID"
                            class="ma-1"
                            style="
                                width: 100px;
                                height: 100px;
                                position: relative;
                            "
                        >
                            <img 
                                :src="image.ImageUrl"
                                :alt="`Zdjęcie-${image.PackageImageID}`"
                                style="
                                    width: 100%;
                                    height: 100%;
                                    object-fit: cover;
                                    border-radius: 10px;
                                "
                            />
                            <div class="white" style="position: absolute; top: -5px; right: -5px; border-radius: 50%;">
                                <v-btn
                                    icon
                                    x-small
                                    color="error"
                                    :loading="packageImageDeleting[image.PackageImageID]"
                                    @click="packageImageDelete(image.PackageImageID)"
                                >
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </div>
                            <div class="black" style="position: absolute; bottom: 0; left: 0; border-top-right-radius: 10px;">
                                <v-btn
                                    icon
                                    small
                                    :color="image.Default ? 'amber' : 'grey lighten-3'"
                                    :loading="packageDefaultImageUpdating[image.PackageImageID]"
                                    @click="packageDefaultImageUpdate(image.PackageImageID)"
                                >
                                    <v-icon>mdi-star</v-icon>
                                </v-btn>
                            </div>
                        </div>
                    </v-row>

                    <div class="text-h6 mt-4">
                        Dodawanie zdjęć
                    </div>
                    <div v-if="packageToStorePackageImage.PackageImages.length >= maxImageNumber">
                        Dodano maksymalną liczbę zdjęć kompletu. 
                    </div>
                    <template v-else>
                        <v-row class="ma-1">
                            <img
                                v-for="(image, i) in imagesPreview" 
                                :key="i"
                                :src="image"
                                :alt="`Nowe-zdjęcie-${i}`"
                                class="ma-1"
                                style="
                                    width: 100px;
                                    height: 100px;
                                    object-fit: cover;
                                    border-radius: 10px;
                                "
                            />
                        </v-row>
                        <v-file-input
                            v-model="packageImageForm.PackageImages"
                            label="Zdjęcia kompletu"
                            hint="Dozwolone formaty: jpg, png, tif. Maksymalny rozmiar: 5Mb."
                            persistent-hint
                            multiple
                            prepend-icon="mdi-camera"
                            :disabled="packageToStorePackageImage.PackageImages.length >= maxImageNumber"
                            :error="$store.getters.hasValidationError('PackageImages')"
                            :error-messages="$store.getters.validationError('PackageImages')"
                        ></v-file-input>
                    </template>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        rounded
                        color="success"
                        :disabled="packageImageForm.PackageImages.length === 0"
                        :loading="packageImageStoring"
                        @click="packageImageStore"
                    >Dodaj</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="packageStockLevelsExportDialog"
            persistent
            width="500"
        >
            <v-card>
                <v-card-title class="headline grey lighten-2 mb-5">
                    Eksport stanów magazynowych
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="hidePackageStockLevelsExportDialog"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-select
                        v-model="distributorId"
                        :items="distributors"
                        label="Dystrybutor*"
                        item-text="Name"
                        item-value="DistributorID"
                    ></v-select>
                    <small>* pole wymagane</small>
                </v-card-text>

                <v-divider></v-divider>

                <template v-if="packageStockLevelsExportShareLink !== null">
                    <div class="grey lighten-5 px-6 pt-3">
                        <v-text-field
                            v-model="packageStockLevelsExportShareLink"
                            label="Link do udostępnienia"
                            readonly
                            @focus="$event.target.select()"
                        ></v-text-field>
                    </div>

                    <v-divider></v-divider>
                </template>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        rounded
                        color="success"
                        :disabled="!distributorId || packageStockLevelsExportShareLink !== null || packageStockLevelsExporting"
                        :loading="packageStockLevelsExportShareLinkGenerating"
                        @click="packageStockLevelsExportShareLinkGenerate"
                    >
                        Udostępnij link
                    </v-btn>
                    <v-btn
                        rounded
                        color="success"
                        :disabled="!distributorId || packageStockLevelsExportShareLinkGenerating"
                        :loading="packageStockLevelsExporting"
                        @click="packageStockLevelsExport"
                    >
                        Eksportuj
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import LoadingMessage from "../../../components/LoadingMessage";
import PackageActivationSwitch from "../../../components/PackageActivationSwitch";
import PackageDefaultSwitch from "../../../components/PackageDefaultSwitch";

export default {
    name: "Packages",
    components: {
        LoadingMessage,
        PackageActivationSwitch,
        PackageDefaultSwitch,
    },
    data() {
        return {
            searchQuery: "",

            packageIndexing: false,
            packages: [],

            packageEditDialog: false,
            packageToEdit: null,
            packageUpdating: false,

            packageImageStoreDialog: false,
            packageToStorePackageImage: null,
            packageImageStoring: false,

            packageImageDeleting: [],
            packageDefaultImageUpdating: [],

            packageImageDisplayDialog: false,
            packageToDisplayPackageImage: null,
            packageImageDisplayIndex: 0,

            packageStockLevelsExportDialog: false,
            packageStockLevelsExporting: false,
            packageStockLevelsExportShareLink: null,
            packageStockLevelsExportShareLinkGenerating: false,

            packageForm: {
                EAN: null,
                PricePLN: null,
                ExternalCodeBRW: null,
                TagIDs: []
            },

            packageImageForm: {
                PackageImages: [],
            },

            maxImageNumber: 10,
            displayImageNumber: 3,
            imagesPreview: [],

            systems: [],
            systemIndexing:false,
            systemId: null,

            blocks: [],
            blockIndexing:false,
            blockId: null,

            tags: [],
            tagIndexing: false,
            tagIds: [],
            
            distributors: [],
            distributorIndexing: false,
            distributorId: null,

            // pagination
            page: 1,
            lastPage:1,
            from: 0,
            to: 0,
            total: 0,
        };
    },
    computed: {
        isMobile() {
            return this.$vuetify.breakpoint.mobile;
        },

        isPageFirst() {
            return this.page === 1;
        },

        isPageLast() {
            return this.page === this.lastPage;
        },

        loadingMessage() {
            return !this.searchQuery
                ? "Pobieranie listy kompletów..."
                : "Wyszukiwanie kompletów...";
        },

        emptyMessage() {
            return !this.searchQuery
                ? "Brak kompletów"
                : "Nie znaleziono kompletów pasujących do podanej frazy";
        },

        tableHeight() {
            return `calc(100vh - 76px - ${this.$vuetify.breakpoint.mdAndUp ? 72 : 212}px - ${this.$store.state.footerHeight}px)`;
        }
    },
    methods: {
        loadPage() {
            //If any request_search is currently in progress, cancel it!
            if (this.$store.state.sources.load_packages) {
                this.$store.state.sources.load_packages.cancel();
            }

            //Run debouncedFetch
            this.debouncedPackageIndexFast();
        },
        nextPage: function () {
            if (this.page < this.lastPage) {
                this.page++;
                this.loadPage();
            }
        },
        prevPage: function () {
            if (this.page > 1) {
                this.page--;
                this.loadPage();
            }
        },
        resetPage () {
            this.page = 1;
        },
        packageIndex () {
            this.packageIndexing = true;

            this.$store.dispatch('packageIndex', {
                page: this.page,
                searchQuery: this.searchQuery,
                systemId: this.systemId,
                blockId: this.blockId,
                tagIds: this.tagIds
            }).then(response => {
                if(response.status === 200) {
                    this.packages = response.data.data;
                    this.page = response.data.meta.current_page ?? 1;
                    this.lastPage = response.data.meta.last_page ?? 1;
                    this.from = response.data.meta.from ?? 0;
                    this.to = response.data.meta.to ?? 0;
                    this.total = response.data.meta.total;

                    this.sortTags();
                } else {
                    this.$store.commit("showSnackbarError", "Błąd ładowania listy kompletów.");
                }
            })
                .catch(error => {})
                .then(() => {
                    this.packageIndexing = false;
                });
        },
        packageUpdate: function () {
            this.packageUpdating = true;

            this.$store.dispatch('packageUpdate', {
                PackageID: this.packageToEdit.PackageID,
                formData: this.packageForm
            }).then(response => {
                if ([200, 201].includes(response.status)) {
                    this.hidePackageEditDialog();
                    this.$store.commit("showSnackbarSuccess", "Zapisano zmiany w komplecie.");
                    this.packageIndex();
                } else {
                    this.$store.commit("showSnackbarError", "Błąd zapisu kompletu.");
                }
            })
                .catch(error => {})
                .then(() => {
                    this.packageUpdating = false;
                });
        },
        packageImageStore: function () {
            this.packageImageStoring = true;
            this.$store.commit("resetValidation");

            this.$store.dispatch('packageImageStore', {
                PackageID: this.packageToStorePackageImage.PackageID,
                formData: this.packageImageForm
            }).then(response => {
                if ([200, 201].includes(response.status)) {
                    this.$store.commit("showSnackbarSuccess", "Zapisano zdjęcie.");
                    this.packageIndex();
                    this.resetPackageImageForm();
                } else {
                    this.$store.commit("showSnackbarError", "Błąd zapisu zdjęcia.");
                }
            })
                .catch(error => {})
                .then(() => {
                    this.packageImageStoring = false;
                });
        },
        packageImageDelete: function (PackageImageID) {
            this.packageImageDeleting[PackageImageID] = true;

            this.$store.dispatch('packageImageDelete', PackageImageID).then(response => {
                if (response.status === 204) {
                    this.$store.commit("showSnackbarSuccess", "Usunięto zdjęcie.");
                    this.packageIndex();
                } else {
                    this.$store.commit("showSnackbarError", "Błąd usuwania zdjęcia.");
                }
            })
                .catch(error => {})
                .then(() => {
                    this.packageImageDeleting[PackageImageID] = false;
                });
        },
        packageDefaultImageUpdate: function (PackageImageID) {
            this.packageDefaultImageUpdating[PackageImageID] = true;

            this.$store.dispatch('packageDefaultImageUpdate', PackageImageID).then(response => {
                if ([200, 201].includes(response.status)) {
                    this.$store.commit("showSnackbarSuccess", "Zmieniono domyślne zdjęcie.");
                    this.packageIndex();
                } else {
                    this.$store.commit("showSnackbarError", "Błąd zmiany domyślnego zdjęcia.");
                }
            })
                .catch(error => {})
                .then(() => {
                    this.packageDefaultImageUpdating[PackageImageID] = false;
                });
        },
        packageStockLevelsExport: function () {
            this.packageStockLevelsExporting = true;

            this.$store.dispatch('packageStockLevelsExport', {
                SearchQuery: this.searchQuery,
                SystemID: this.systemId,
                BlockID: this.blockId,
                DistributorID: this.distributorId,
                TagIDs: this.tagIds
            }).then(response => {
                if ([200, 201].includes(response.status)) {
                    if (response.data.data.ExportUrl) {
                        window.open(response.data.data.ExportUrl, '_blank', 'noopener noreferrer');
                    }
                } else {
                    this.$store.commit("showSnackbarError", "Błąd exportu.");
                }
            })
                .catch(error => {})
                .then(() => {
                    this.packageStockLevelsExporting = false;
                });
        },
        packageStockLevelsExportShareLinkGenerate: function () {
            this.packageStockLevelsExportShareLinkGenerating = true;

            this.$store.dispatch('packageStockLevelsExport', {
                SearchQuery: this.searchQuery,
                SystemID: this.systemId,
                BlockID: this.blockId,
                DistributorID: this.distributorId,
                TagIDs: this.tagIds
            }).then(response => {
                if ([200, 201].includes(response.status)) {
                    this.packageStockLevelsExportShareLink = response.data.data.ExportUrl;
                    this.$store.commit("showSnackbarSuccess", "Wygenerowano link do udostępnienia.");
                } else {
                    this.$store.commit("showSnackbarError", "Błąd generowania linku.");
                }
            })
                .catch(error => {})
                .then(() => {
                    this.packageStockLevelsExportShareLinkGenerating = false;
                });
        },
        systemIndex () {
            this.systemIndexing = true;

            this.$store.dispatch('loadSystems', {
                allSystems: 1,
            }).then(response => {
                if(response.status === 200) {
                    this.systems = response.data.data;
                } else {
                    this.$store.commit("showSnackbarError", "Błąd ładowania listy systemów.");
                }
            })
                .catch(error => {})
                .then(() => {
                    this.systemIndexing = false;
                });
        },
        blockIndex () {
            this.blockIndexing = true;

            this.$store.dispatch('loadSystemBlocks',this.systemId).then(response => {
                if(response.status === 200) {
                    this.blocks = response.data.data;
                } else {
                    this.$store.commit("showSnackbarError", "Błąd ładowania listy brył.");
                }
            })
                .catch(error => {})
                .then(() => {
                    this.blockIndexing = false;
                });
        },
        tagIndex () {
            this.tagIndexing = true;

            this.$store.dispatch('tagIndex')
                .then(response => {
                    if (response.status === 200) {
                        this.tags = response.data.data;
                    } else {
                        this.$store.commit("showSnackbarError", "Błąd ładowania listy tagów.");
                    }
                })
                .catch(error => {})
                .then(() => {
                    this.tagIndexing = false;
                });
        },
        sortTags () {
            this.packages.forEach(pkg => {
                pkg.Tags.sort((a, b) => a.TagID-b.TagID);
            });
        },
        distributorIndex () {
            this.distributorIndexing = true;

            this.$store.dispatch('distributorIndex').then(response => {
                if(response.status === 200) {
                    this.distributors = response.data.data;
                } else {
                    this.$store.commit("showSnackbarError", "Błąd ładowania listy dystrybutorów.");
                }
            })
                .catch(error => {})
                .then(() => {
                    this.distributorIndexing = false;
                });
        },
        showPackageEditDialog: function (pkg) {
            this.packageToEdit = pkg;
        },
        hidePackageEditDialog: function () {
            this.packageEditDialog = false;
        },
        showPackageImageStoreDialog: function (pkg) {
            this.packageToStorePackageImage = pkg;
        },
        hidePackageImageStoreDialog: function () {
            this.packageImageStoreDialog = false;
        },
        showPackageImageDisplayDialog: function (pkg, index) {
            this.packageToDisplayPackageImage = pkg;
            this.packageImageDisplayIndex = index;
        },
        hidePackageImageDisplayDialog: function () {
            this.packageImageDisplayDialog = false;
        },
        showPackageStockLevelsExportDialog: function () {
            this.packageStockLevelsExportDialog = true;
        },
        hidePackageStockLevelsExportDialog: function () {
            this.packageStockLevelsExportDialog = false;
        },
        resetPackageImageForm: function () {
            this.packageImageForm.PackageImages = [];
        },
        resetPackageForm: function () {
            for (const index in this.packageForm) {
                this.packageForm[index] = null;
            }
        },
        setPackageForm: function (pkg) {
            this.packageForm.EAN = pkg.EAN;
            this.packageForm.PricePLN = pkg.PricePLN;
            this.packageForm.ExternalCodeBRW = pkg.ExternalCodeBRW;
            this.packageForm.TagIDs = pkg.Tags.map(t => t.TagID);
        },
    },
    created() {
        this.debouncedPackageIndex = _.debounce(this.packageIndex, 900);
        this.debouncedPackageIndexFast = _.debounce(this.packageIndex, 300);

        this.packageIndex();
        this.systemIndex();
        this.tagIndex();
        this.distributorIndex();
    },
    watch: {
        searchQuery: function () {
            this.resetPage();

            //If any request_search is currently in progress, cancel it!
            if (this.$store.state.sources.load_packages) {
                this.$store.state.sources.load_packages.cancel();
            }

            //Run debouncedFetch
            this.debouncedPackageIndex();
        },
        systemId: function (systemId) {
            this.resetPage();

            //If any request_search is currently in progress, cancel it!
            if (this.$store.state.sources.package_index) {
                this.$store.state.sources.package_index.cancel();
            }

            this.blocks = [];
            if (systemId !== null) {
                this.blockIndex();
            }

            if (this.blockId !== null) {
                this.blockId = null;
            } else {
                this.debouncedPackageIndexFast();
            }
        },
        blockId: function () {
            this.resetPage();

            //If any request_search is currently in progress, cancel it!
            if (this.$store.state.sources.package_index) {
                this.$store.state.sources.package_index.cancel();
            }

            //Run debouncedFetch
            this.debouncedPackageIndexFast();
        },
        tagIds: function () {
            this.resetPage();

            //If any request_search is currently in progress, cancel it!
            if (this.$store.state.sources.package_index) {
                this.$store.state.sources.package_index.cancel();
            }

            //Run debouncedFetch
            this.debouncedPackageIndex();
        },
        packageToEdit: function (pkg) {
            if(pkg !== null) {
                this.setPackageForm(pkg);
                this.packageEditDialog = true;
            }
        },
        packageEditDialog: function (visible) {
            if(!visible) {
                this.resetPackageForm();
                this.$store.commit("resetValidation");
                this.packageToEdit = null;
            }
        },

        packageToStorePackageImage: function (pkg) {
            if(pkg !== null) {
                this.packageImageStoreDialog = true;
            }
        },
        packageImageStoreDialog: function (visible) {
            if(!visible) {
                this.resetPackageImageForm();
                this.$store.commit("resetValidation");
                this.packageToStorePackageImage = null;
            }
        },

        packageToDisplayPackageImage: function (pkg) {
            if (pkg !== null) {
                this.packageImageDisplayDialog = true;
            }
        },
        packageImageDisplayDialog: function (visible) {
            if (!visible) {
                this.packageToDisplayPackageImage = null;
            }
        },

        packageStockLevelsExportDialog: function (visible) {
            if(!visible) {
                this.packageStockLevelsExportShareLink = null;
            }
        },
        distributorId: function () {
            this.packageStockLevelsExportShareLink = null;
        },
        'packageImageForm.PackageImages': function () {
            this.imagesPreview = this.packageImageForm.PackageImages?.map(
                i => URL.createObjectURL(i)
            ) || [];
        },
        packages: function () {
            if (this.packageToStorePackageImage !== null) {
                const pkg = this.packages.find(
                    p => p.PackageID === this.packageToStorePackageImage.PackageID
                );
                if (pkg) {
                    this.showPackageImageStoreDialog(pkg);
                }
            }
        },
    }
}
</script>

<style scoped>

</style>
